export function getVerticalScrollParent(element: HTMLElement): HTMLElement | null {
  let parent = element.parentElement;
  while (parent) {
    const { overflowY } = getComputedStyle(parent);
    if (
      (overflowY === 'auto' || overflowY === 'scroll' || overflowY === 'overlay') &&
      parent.scrollHeight > parent.clientHeight
    ) {
      return parent;
    }
    parent = parent.parentElement;
  }
  return null;
}

export function scrollElementToTop(
  element: HTMLElement,
  options?: { offsetPx?: number; behavior?: ScrollBehavior }
): void {
  const offsetPx = options?.offsetPx ?? 0;
  const behavior = options?.behavior ?? 'smooth';
  const scrollParent = getVerticalScrollParent(element);

  if (scrollParent) {
    const parentRect = scrollParent.getBoundingClientRect();
    const elementRect = element.getBoundingClientRect();
    const nextTop = scrollParent.scrollTop + (elementRect.top - parentRect.top) - offsetPx;
    scrollParent.scrollTo({ top: Math.max(0, nextTop), behavior });
    return;
  }

  const nextTop = element.getBoundingClientRect().top + window.scrollY - offsetPx;
  window.scrollTo({ top: Math.max(0, nextTop), behavior });
}

export function scrollElementIntoView(
  element: HTMLElement,
  options?: { behavior?: ScrollBehavior; block?: 'start' | 'center' }
): void {
  const behavior = options?.behavior ?? 'smooth';
  const block = options?.block ?? 'start';
  const scrollParent = getVerticalScrollParent(element);

  if (scrollParent) {
    const parentRect = scrollParent.getBoundingClientRect();
    const elementRect = element.getBoundingClientRect();
    let nextTop = scrollParent.scrollTop + (elementRect.top - parentRect.top);
    if (block === 'center') {
      nextTop -= (scrollParent.clientHeight - elementRect.height) / 2;
    }
    scrollParent.scrollTo({ top: Math.max(0, nextTop), behavior });
    return;
  }

  if (typeof element.scrollIntoView === 'function') {
    element.scrollIntoView({ behavior, block });
  }
}
